import { useFormikContext } from "formik";
import PhoneInput from "react-phone-input-2";

const Phone = ({ value, name, handleChange }) => {

  const { setFieldValue } = useFormikContext();

  const handlePhoneChange = (phone) => { 
    setFieldValue(name, phone);
    handleChange && handleChange({name, phone})
  };

  const containerStyles = {
    width: "100%",
    borderRadius: '0',
  };
  
  const inputStyles = {
    width: "100%",
    height:"2.3rem",
    borderRadius: '0',
    border:'1px solid #e5e7eb',
    backgroundColor: 'var(--bg-color)',
    color: 'var(--color-2)',
  };

  return (
    <PhoneInput
      country={"gh"}
      value={value}
      onChange={handlePhoneChange}
      countryCodeEditable={false}
      disableSearchIcon={true}
      inputProps={{
        name: {name},
        required: true,
        autoFocus: true,
      }}
      containerStyle={containerStyles}
      inputStyle={inputStyles}     
    />
  );
};

export default Phone;
